import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UserAddressService } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';
import { CustomIconsModule } from "../../../../../../custom/icons/custom-icons.module";
import { CustomAddressFormModule } from '../../../../../custom/cms-components/checkout/components/custom-shipping-address/address-form/custom-address-form.module';
import { CustomCardModule } from '../../../../../custom/shared/components/custom-card/custom-card.module';
import { CustomAddressBookComponent } from './custom-address-book.component';
import { CustomAddressBookComponentService } from './custom-address-book.component.service';

@NgModule({
  imports: [
    CommonModule,
    CustomCardModule,
    SpinnerModule,
    I18nModule,
    CustomIconsModule,
    CustomAddressFormModule,
    CustomCardModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountAddressBookComponent: {
          component: CustomAddressBookComponent,
          providers: [
            {
              provide: CustomAddressBookComponentService,
              useClass: CustomAddressBookComponentService,
              deps: [UserAddressService],
            },
          ],
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [UserAddressService],
  declarations: [CustomAddressBookComponent],
  exports: [CustomAddressBookComponent]
})
export class CustomAddressBookModule { }
